import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { X, Megaphone, ArrowUpRight } from "lucide-react";

const DISMISS_KEY = "bec-migration-banner-dismissed";
const NEW_REGISTER =
  "https://becc.takumiwhm.com/auth/register?tenantHost=becc.takumiwhm.com&returnUrl=https%3A%2F%2Fbecc.takumiwhm.com";
const OLD_LOGIN = "https://bec.tasoko.com/login";

export const MigrationBanner = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (localStorage.getItem(DISMISS_KEY)) return;
    const t = setTimeout(() => setVisible(true), 2500);
    return () => clearTimeout(t);
  }, []);

  const dismiss = () => {
    localStorage.setItem(DISMISS_KEY, "1");
    setVisible(false);
  };

  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          data-testid="migration-banner"
          initial={{ opacity: 0, y: 40, scale: 0.96 }}
          animate={{ opacity: 1, y: 0, scale: 1 }}
          exit={{ opacity: 0, y: 40, scale: 0.96 }}
          transition={{ duration: 0.45, ease: [0.22, 1, 0.36, 1] }}
          className="fixed bottom-6 left-5 right-5 sm:left-6 sm:right-auto z-[70] sm:max-w-sm rounded-2xl border border-[#FF8A00]/30 bg-[#1C0D2C]/90 backdrop-blur-xl inner-glow p-5"
        >
          <button
            data-testid="migration-banner-dismiss"
            onClick={dismiss}
            aria-label="Dismiss notice"
            className="absolute top-3 right-3 p-1.5 rounded-full text-[#A29DB0] hover:text-white hover:bg-white/10 transition-colors duration-200"
          >
            <X className="w-4 h-4" />
          </button>

          <div className="flex items-center gap-2.5 mb-3 pr-8">
            <Megaphone className="w-4 h-4 text-[#FF8A00] shrink-0" />
            <p className="font-mono-accent text-xs tracking-widest uppercase text-[#FF8A00]">
              We're upgrading
            </p>
          </div>

          <p className="text-sm text-[#F8F7FA] leading-relaxed mb-4">
            BEC Couriers is moving to a new account system.{" "}
            <span className="text-[#A29DB0]">
              New customers: create your free mailbox on the new site. Existing
              customers: your current login still works.
            </span>
          </p>

          <div className="flex flex-col gap-2">
            <a
              data-testid="migration-banner-register"
              href={NEW_REGISTER}
              target="_blank"
              rel="noreferrer"
              className="group px-4 py-2.5 rounded-full bg-[#FF8A00] text-[#12071F] text-sm font-semibold hover:bg-[#FF9F2E] transition-colors duration-200 flex items-center justify-center gap-1.5"
            >
              Create new account
              <ArrowUpRight className="w-3.5 h-3.5 transition-transform duration-200 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
            </a>
            <a
              data-testid="migration-banner-old-login"
              href={OLD_LOGIN}
              target="_blank"
              rel="noreferrer"
              className="px-4 py-2 rounded-full border border-white/15 text-xs text-[#A29DB0] hover:text-white hover:bg-white/10 transition-colors duration-200 text-center"
            >
              Existing customer? Login to the old system
            </a>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};
